import React, { useState, useEffect } from 'react';
import styles from './pdfdoc.module.css';
import CommonBtn from '../CommonBtn/CommonBtn';
import PopUp from '../../../common/components/PopUp/PopUp';
import GlobalPdfViewer from '../../../common/components/GlobalPDFViewer/GlobalPdfViewer';
import Modal from '../../../common/components/Modal/modal';
import SendToBank from './SendToBank';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { getPDFDoc } from '../../../common/constants/api';
import { getUserType } from '../../../common/utils/cookie-utils';
const { pdf_frame, pdf_txt } = styles;
const PDFDocument = ({ showPDFDoc }) => {
  const [loading, setLoading] = useState(false);
  const [popType, setPopType] = useState('loading');
  const [popUpText, setPopUpText] = useState('Generating PDF..');
  const [showDoc, setShowDoc] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [myfile, setMyfile] = useState('');
  const [status, setStatus] = useState(0);
  const [userType, setUserType] = useState(getUserType());
  useEffect(() => {
    let applicant = getApplicantionInfo();
    setLoading(true);
    getPDFDoc(applicant.leadId)
      .then(res => {
        setMyfile(res);
        setLoading(false);
        setShowDoc(true);
      })
      .catch(err => {
        setPopType('fail');
        setStatus(err?.response?.data?.status);
        setPopUpText(err?.response?.data?.message);
      });
  }, [showPDFDoc]);
  const sendtoBank = () => {
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <PopUp
        setShow={setLoading}
        show={loading}
        type={popType}
        text={status !== 500 ? popUpText : 'Something went wrong!'}
        dontClose={status !== 404 && status !== 500}
        goto={status === 403}
      />
      {showDoc ? (
        <div className="bg-white border border-navy-400 mt-10 relative m-auto text-black-400 font-normal py-10 ml-6 mr-6 text-center">
          <div
            className={`${pdf_txt} w-full lg:w-8/12 md:w-8/12  mx-auto h-auto px-2`}
          >
            <div className="flex flex-col xxmd:flex-row xxmd:justify-between xxmd:items-center mb-2 md:mb-6 ">
              <div className="flex font-roboto">
                <p className="text-black-400 text-xl font-bold ">
                  PDF Document
                </p>
              </div>
              {userType == 2 ? (
                <div className="flex flex-col ">
                  <CommonBtn
                    value="Send To Bank"
                    stylesBtn={{
                      backgroundColor: 'teal',
                      color: 'white',
                      padding: '5px 35px 5px 35px'
                    }}
                    onClick={sendtoBank}
                  />
                </div>
              ) : null}
            </div>
            <div className={`bg-black-700 px-10 px-5 py-5 pb-10 ${pdf_frame} `}>
              <GlobalPdfViewer file={myfile} renderMode={'svg'} />
            </div>
          </div>
        </div>
      ) : null}
      <Modal show={showModal} setShow={setShowModal}>
        <SendToBank setShowParrent={setShowModal} />
      </Modal>
    </React.Fragment>
  );
};
export default PDFDocument;
